import React, { useState, useEffect } from "react";

import { CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Skeleton } from "./ui/skeleton";
import coin from "../assets/images/placeholder/crypto-colour.png";
import { Loader2 } from "lucide-react";
import investGraphic from "../assets/images/invest/invest_complete.svg";
import CurrencyFormatter from "../utils/currencyFormatter";
import { logger } from "../utils/logger";
export default function DepositInvest({
  ledgerProduct,
  assetsOwned,
  pageNo,
  setParentAmount,
  isQuoting,
  onDepositQuote,
  amount,
  depositsEnabled,
}) {
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [depositAmount, setDepositAmount] = useState(null);
  const [loadingAsset, setLoadingAsset] = useState(true);
  const [holdStep, setHoldStep] = useState(true);
  const [minFlag, setMinFlag] = useState(false);
  const [availFlag, setAvailFlag] = useState(false);
  const [maxFlag, setMaxFlag] = useState(false);
  const [valueFlag, setValueFlag] = useState(false);

  const assetId = ledgerProduct?.productId?.assetId?._id;
  const asset = ledgerProduct?.productId?.assetId?.asset;
  const minDeposit = ledgerProduct?.productId?.minDeposit?.$numberDecimal;
  const maxDeposit = ledgerProduct?.productId?.maxDeposit?.$numberDecimal;
  const prodValue = ledgerProduct?.productId?.value?.$numberDecimal;
  const capital = amount?.capital;
  const formatter = new CurrencyFormatter();
  // useEffect(() => {
  //   try {
  //     const selectAsset = () => {
  //       const assetSelected = assetsOwned?.find(
  //         (asset) => asset.assetId === assetId
  //       );

  //       setSelectedAsset(assetSelected);
  //     };
  //     selectAsset();
  //   } catch (error) {
  //     logger.error("Error selecting asset", error);
  //   }
  // }, [assetsOwned]);

  // useEffect(() => {
  //   if (!selectedAsset) return;
  //   if (selectedAsset) {
  //     setLoadingAsset(false);
  //   }
  // }, [selectedAsset]);
  useEffect(() => {
    if (!assetsOwned || !Array.isArray(assetsOwned)) return;

    const assetSelected = assetsOwned.find(
      (asset) => asset.assetId === assetId
    );

    if (assetSelected) {
      setSelectedAsset(assetSelected);
    } else {
      logger.warn(`Asset with ID ${assetId} not found.`);
      setSelectedAsset(null); // or some default asset if you prefer
    }
  }, [assetsOwned, assetId]);

  useEffect(() => {
    setLoadingAsset(!selectedAsset ? false : false);
  }, [selectedAsset]);

  const handleAmount = (e) => {
    const rawValue = e.target.value;
    const value = parseFloat(rawValue);
    const available = parseFloat(selectedAsset?.availableAmount || 0);
    const min = parseFloat(minDeposit);
    const max = parseFloat(maxDeposit);
    const capitalValue = parseFloat(capital);
    const productLimit = parseFloat(prodValue);
    const depositWithCapital = capitalValue + value;

    // Set raw input for UI
    setDepositAmount(rawValue);
    setParentAmount(rawValue);

    // Reset all flags first
    let hold = false;
    setMinFlag(false);
    setMaxFlag(false);
    setAvailFlag(false);
    setValueFlag(false);

    if (!rawValue || isNaN(value)) {
      setHoldStep(true);
      return;
    }

    if (value < min) {
      setMinFlag(true);
      hold = true;
    }

    if (value > max) {
      setMaxFlag(true);
      hold = true;
    }

    if (value > available) {
      setAvailFlag(true);
      hold = true;
    }

    if (depositWithCapital > productLimit) {
      setValueFlag(true);
      hold = true;
    }

    // if (valueWithFee > productLimit) {
    //   setFeeLimitFlag(true);
    //   hold = true;
    // }

    setHoldStep(hold);
  };

  const quoteDeposit = () => {
    onDepositQuote?.();
  };
  return (
    <>
      {pageNo === 0 && (
        <div className="px-20">
          {depositsEnabled === true ? (
            <CardContent>
              <div className="grid grid-cols-6 gap-4 grid-rows-1 mb-3">
                <div className="space-y-2 col-span-1">
                  <label className="text-gray-600 text-sm">Deposit</label>
                  {loadingAsset ? (
                    <div className="w-full flex items-center justify-between py-4  px-4 rounded-2xl border border-gray-300 bg-muted/50">
                      <div className="flex items-center gap-3 ">
                        <Skeleton className="w-10 h-10 rounded-full bg-gray-300" />

                        <div className="flex flex-col gap-1">
                          <Skeleton className="w-10 h-5 rounded-full bg-gray-300" />
                        </div>
                      </div>
                      <Skeleton className="w-6 h-6 rounded-full bg-gray-300" />
                    </div>
                  ) : (
                    <Button
                      variant="outline"
                      className="w-full flex items-center justify-between py-9 rounded-2xl hover:border-brand-primary transition-colors"
                    >
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full flex items-center justify-center">
                          {selectedAsset ? (
                            <img
                              src={
                                selectedAsset?.assetIcon || selectedAsset?.image
                              }
                              alt={selectedAsset?.assetName}
                              width={32}
                              height={32}
                              className="text-white"
                            />
                          ) : (
                            <img
                              src={coin}
                              alt="Default Asset"
                              width={32}
                              height={32}
                              className="text-white"
                            />
                          )}
                        </div>
                        <div className="text-left">
                          <div className="font-semibold">
                            {selectedAsset?.asset.toUpperCase()}
                          </div>
                        </div>
                      </div>
                    </Button>
                  )}
                </div>
                <div className="space-y-2 col-span-5">
                  <label className="text-gray-600 text-sm">
                    Digital Wallet balance
                  </label>
                  <div className="px-5 py-6 rounded-2xl bg-gray-50 flex-1 flex items-center">
                    <div className="text-xl font-semibold text-gray-600">
                      {selectedAsset?.availableAmountFormatted}
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-800 mb-2">
                  Enter amount
                </label>
                <div
                  className={`relative flex items-center border rounded-lg px-4 py-2 bg-transparent  ${
                    minFlag ||
                    maxFlag ||
                    availFlag ||
                    valueFlag ||
                    false ||
                    false
                      ? "border-2 border-rose-500 "
                      : " "
                  }`}
                >
                  <input
                    type="text"
                    placeholder="R 0"
                    value={depositAmount}
                    onChange={handleAmount}
                    className={`flex-1 py-5 text-base font-semibold bg-transparent outline-none 
                      focus-visible:ring-0 focus-visible:outline-none transition-colors duration-200 ease-in-out text-[24px] text-text-secondary
                    ${
                      minFlag ||
                      maxFlag ||
                      availFlag ||
                      valueFlag ||
                      false ||
                      false
                        ? "text-rose-500"
                        : "text-brand-primary"
                    }`}
                  />
                  <Button
                    onClick={() =>
                      setDepositAmount(selectedAsset?.availableAmount)
                    }
                    variant="outline"
                    className="rounded-full"
                  >
                    Max
                  </Button>
                </div>
                {minFlag && (
                  <p className="mt-1 text-sm text-rose-500">
                    This amount is less than the minimum allowed amount of
                    {formatter.format(minDeposit, asset?.toUpperCase())}
                  </p>
                )}
                {maxFlag && (
                  <p className="mt-1 text-sm text-rose-500">
                    This amount is above the maximum allowed amount{" "}
                    {formatter.format(maxDeposit, asset?.toUpperCase())}
                  </p>
                )}
                {valueFlag && (
                  <p className="mt-1 text-sm text-rose-500">
                    The amount with existing deposits exceeded the investment
                    value of
                    {formatter.format(prodValue, asset?.toUpperCase())}
                  </p>
                )}
                {availFlag && (
                  <p className="mt-1 text-sm text-rose-500">
                    This amount is above your balance{" "}
                    {formatter.format(
                      selectedAsset?.availableAmount,
                      asset?.toUpperCase()
                    )}
                  </p>
                )}
              </div>

              <div className="flex justify-center">
                <Button
                  disabled={holdStep || isQuoting}
                  onClick={quoteDeposit}
                  className="py-4 px-[170px] h-15 bg-gradient-to-tr from-purple-500 to-rose-500 text-white rounded-full font-bold mt-5"
                >
                  {isQuoting && <Loader2 className="animate-spin w-4 h-4" />}
                  Continue
                </Button>
              </div>
            </CardContent>
          ) : (
            <CardContent>
              <div className="flex flex-col items-center justify-center">
                <img src={investGraphic} alt="" className="mb-4" />
                <div className="font-bold text-xl text-center">
                  Deposits have been deactivated
                </div>
              </div>
            </CardContent>
          )}
        </div>
      )}
    </>
  );
}
